export default __webpack_public_path__ + "static/media/shopping-basket-4.c0ecf5fa.png";